var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("form-button-disabler", [
    _c("div", { staticClass: "w-full flex pt-2 flex-col" }, [
      _c(
        "div",
        { staticClass: "w-full" },
        [
          _c(
            "field",
            { staticClass: "mb-3", attrs: { label: "Loan ID" } },
            [
              _c("text-field", {
                attrs: { value: _vm.loanId.toString(), disabled: true },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "field",
            { staticClass: "mb-3", attrs: { label: "Old Servicer Loan ID" } },
            [
              _c("text-field", {
                attrs: { placeholder: "Enter Old Servicer Loan ID" },
                model: {
                  value: _vm.oldServicerLoanId,
                  callback: function ($$v) {
                    _vm.oldServicerLoanId = $$v
                  },
                  expression: "oldServicerLoanId",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "field",
            { staticClass: "mb-2", attrs: { label: "New Servicer Loan ID" } },
            [
              _c("text-field", {
                attrs: { placeholder: "Enter New Servicer Loan ID" },
                model: {
                  value: _vm.newServicerLoanId,
                  callback: function ($$v) {
                    _vm.newServicerLoanId = $$v
                  },
                  expression: "newServicerLoanId",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "flex flex-row-reverse pt-4" },
        [
          _c(
            "btn",
            {
              on: {
                click: function ($event) {
                  return _vm.closeProp()
                },
              },
            },
            [_vm._v("Override")]
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }